<template>
  <div>
    <el-radio-group v-model="val" @change="$emit('change', $event)">
      <el-radio v-for="option in options"
                :key="option[valueAttr]"
                :disabled="option['disabled']"
                :label="option[valueAttr]">{{ option[labelAttr] }}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {},
    options: {},
    labelAttr: {
      default: "name"
    },
    valueAttr: {
      default: "id"
    },
  },
  data() {
    return {
      val: this.value
    }
  },
  watch: {
    value: function(value) {
      this.val = value;
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cx/cxRadio.vue